// extracted by mini-css-extract-plugin
export var content = "CarbonFreeSection-module--content--afb32";
export var core = "CarbonFreeSection-module--core--e2807";
export var hero = "CarbonFreeSection-module--hero--d45a2";
export var heroContent = "CarbonFreeSection-module--hero-content--fd5d7";
export var text = "CarbonFreeSection-module--text--c3f79";